/**
 * 実行
 */

import { listen, prefetch } from "quicklink";
import 'intersection-observer';
import isn from './intersection.js';
import fun from './functions.js';
import smoothscroll from "smoothscroll-polyfill";

(function () {
  "use strict";

  document.body.classList.add("js-validity");

  isn.DataElementHide("[data-element_hide]");
  isn.DataScroll("[data-scroll]");
  isn.DataSrc("[data-src]");
  isn.DataHref("[data-href]");
  isn.DataBack("[data-back]");
  smoothscroll.polyfill();
  fun.SmoothLink();

  const data_click = document.querySelectorAll("[data-click]");
  for (let i = 0, len = data_click.length; i < len; ++i) {
    data_click[i].addEventListener("click", e => {
      const click = data_click[i].dataset.click;
      switch (click) {
        case "menu":
          if (data_click[i].getAttribute("aria-expanded") == "false") {
            fun.MenuOpen(data_click[i]);
          } else {
            fun.MenuClose(data_click[i]);
          }
          break;
        case "toggle":
          fun.ClickToggle(data_click[i]);
          break;
        case "go_top":
          fun.ClickGoTop(data_click[i]);
          break;
        case "modal_open":
          fun.ClickModalOpen(data_click[i]);
          break;
        case "modal_close":
          fun.ClickModalClose(data_click[i]);
          break;
      }
    });
  }

  const data_tab = document.querySelectorAll("[data-tab] > li");
  for (let i = 0, len = data_tab.length; i < len; ++i) {
    data_tab[i].addEventListener("click", e => {
      fun.ClickTab(data_tab[i]);
    });
  }

  const toggle_submenu_ac_val = document.body.dataset.toggle_submenu_ac_flag;
  if (toggle_submenu_ac_val == true) {
    const data_has_children = document.querySelectorAll("#toggle-navigation .menu-item-has-children");
    for (let i = 0, len = data_has_children.length; i < len; ++i) {
      data_has_children[i].addEventListener("click", e => {
        fun.ClickToggle(data_has_children[i]);
      });
    }
  }

  const targetblank_flag_val = document.body.dataset.targetblank_flag;
  if (targetblank_flag_val == true) {
    fun.TargetBlank();
  }

  const links = document.querySelectorAll('a[href*="#"]');
  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener("click", e => {
      const hash = links[i].hash;
      const href = links[i].href;
      const hrefPageUrl = href.split("#")[0];
      const location_href = location.href;
      const currentUrl = location_href.split("#")[0];
      if (hrefPageUrl == currentUrl) {
        e.preventDefault();
        if (links[i].classList.contains("js-not-smooth-scroll")) return;
        fun.SmoothLinkSame(hash);
        if (document.getElementById("menu_button")) {
          fun.MenuClose(document.getElementById("menu_button"));
        }
      }
    });
  }

  window.addEventListener('load', () => {
    const quicklink_flag_val = document.body.dataset.quicklink_flag;
    if (quicklink_flag_val == true) {
      fun.Quicklink(listen);
    }
  });
})();

/**
 * add function 
 */

//spメニュー開閉
(()=>{
  if(document.getElementById("menu-global")){
    let menuGlobal = document.getElementById("menu-global");
    let openButtons = menuGlobal.getElementsByClassName('button');
    for (const openButton of openButtons) {
      openButton.addEventListener("click",()=>{
        openButton.classList.toggle("open");
      },false);
    }
  } else if(document.getElementById("menu-global-ch")){
    let menuGlobal = document.getElementById("menu-global-ch");
    let openButtons = menuGlobal.getElementsByClassName('button');
    for (const openButton of openButtons) {
      openButton.addEventListener("click",()=>{
        openButton.classList.toggle("open");
      },false);
    }
  } else if(document.getElementById("menu-global-en")){
    let menuGlobal = document.getElementById("menu-global-en");
    let openButtons = menuGlobal.getElementsByClassName('button');
    for (const openButton of openButtons) {
      openButton.addEventListener("click",()=>{
        openButton.classList.toggle("open");
      },false);
    }
  }

})();

